import Accordion from "./Accordion";
import BackInStock from "./BackInStock";
import ProductCard from "./ProductCard";
import ProductInfo from "./ProductInfo";
import ProductReviews from "./ProductReviews";
import QuantityInput from "./QuantityInput";
customElements.define('accordion-list', Accordion);
customElements.define('back-in-stock-form', BackInStock);
customElements.define('quantity-input', QuantityInput);
customElements.define('product-info', ProductInfo);
customElements.define('product-card', ProductCard);
customElements.define('product-reviews', ProductReviews);